export const update = {
  updateSuccessfully: 'Update detergent history successfully!',
}
